import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs/Rx';

import { BtLocalService } from './local-data-services/bt-local.service';

@Injectable()
export class TabsService {

  tab1Title: string;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
    this.translateService.get('TAB1_TITLE').subscribe(
      tab1Title => this.tab1Title = tab1Title
    );
  }

  private tab1UpdateSource = new Subject<string>();

  tab1Updated$ = this.tab1UpdateSource.asObservable();

  public getTab1AltTitle(): Observable<string> {
    let bt = BtLocalService.getBT();
    return Observable.of('Mesures - BT n° ' + bt.number + '/' + bt.indice);
  }

  public getTab1RootTitle(): Observable<string> {
    return this.translateService.get('TAB1_TITLE');
  }

  public updateTab1(title?: string) {
    this.tab1UpdateSource.next(title);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/tabs.service.ts